import script from "./CarModelList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarModelList.vue?vue&type=script&lang=ts&setup=true"

import "./CarModelList.vue?vue&type=style&index=0&id=76e732bc&lang=scss"

const __exports__ = script;

export default __exports__